import { inject } from '@angular/core';
import { injectTranslation, QueryBus } from '@skylab-angular-shared/core';
import { ToastService } from '@skylab-angular-shared/ui';
import { ClientBO, ClientUtils, GusDataByTinQuery, GusTechnicalBreakCode, GusUnavailableErrorCode, NipValidator } from '@skylab-shared/business';
import { AxiosError } from 'axios';

export const clientSetDataFromGus = async (
	bo: ClientBO,
): Promise<{success: boolean}> => {
	if (!bo.model.tin) return { success: false };

	const queryBus = inject(QueryBus);
	const toastService = inject(ToastService);
	const _T = injectTranslation();

	const normalizedTin = bo.model.normalizedTin;
	if (NipValidator.isValid(normalizedTin)) {
		try {
			const data = await queryBus.queryAsync(new GusDataByTinQuery(normalizedTin));
			ClientUtils.setGusData(bo.model, data);
			return { success: true };
		} catch (err) {
			const error = err as AxiosError & { data?: any };
			if (error.status === 400) {
				toastService.showAsync({
					type: 'error',
					text: _T('scenes.shared.form.gus.nip-incorrect')
				});
			} else if (error.status === 404) {
				toastService.showAsync({
					type: 'error',
					text: _T('scenes.shared.form.gus.nip-not-found')
				});
			} else if (error.status === 502) {
				toastService.showAsync({
					type: 'error',
					text: error.data?.message
				});
			} else if (error.status === 503) {
				toastService.showAsync({
					type: 'error',
					text: error.data?.code === GusUnavailableErrorCode
						? _T('scenes.shared.form.gus.gus-unavailable')
						: error.data?.code === GusTechnicalBreakCode
							? _T('scenes.shared.form.gus.gus-technical-break')
							: error.data?.message
				});
			} else if (error.status === 504) {
				toastService.showAsync({
					type: 'error',
					text: _T('scenes.shared.form.gus.gus-unavailable')
				});
			}
		}
	} else {
		toastService.showAsync({
			type: 'error',
			text: _T('scenes.shared.form.gus.nip-search-incorrect')
		});
	}
	return { success: false };
}
